import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';

import TopBar from './TopBar';
import LocationButton from './LocationButton';

function PromotionModel() {
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <TopBar/>
      <BottomWrapper>
        <LocationButton nowPage={'Promotion'} />
        <TextWrapper>
          <Title style={{ marginTop: `38px` }}>{t('rules.promotion.t1')}</Title>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.promotion.p1')}
          </Text>

          <Title style={{ marginTop: `38px`}}>{t('rules.promotion.t2')}</Title>
          <Text>
            {t('rules.promotion.p2')}
          </Text>
          <Text>
            {t('rules.promotion.p3')}
          </Text>
          <Text>
            {t('rules.promotion.p4')}
          </Text>

          <Title style={{ marginTop: `38px`}}>{t('rules.promotion.t3')}</Title>
          <Text>
            {t('rules.promotion.p5')}
          </Text>
          <Text>
            {t('rules.promotion.p6')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.promotion.t4')}</Title>
          <Text>
            {t('rules.promotion.p7')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.promotion.t5')}</Title>
          <Text>
            {t('rules.promotion.p8')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.promotion.t6')}</Title>
          <Bold>{t('rules.promotion.b1')}</Bold>

          <Text style={{ marginTop: `14px` }}>
            {t('rules.promotion.p9')}
          </Text>
          <Text>
            {t('rules.promotion.p10')}
          </Text>
          <Text>
            {t('rules.promotion.p11')}
          </Text>
          <Text>
            {t('rules.promotion.p12')}
          </Text>
          <Text>
            {t('rules.promotion.p13')}
          </Text>
          <Text>
            {t('rules.promotion.p14')}
          </Text>
          <Text>
            {t('rules.promotion.p15')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.promotion.t7')}</Title>
          <Bold>
            {t('rules.promotion.b2')}
          </Bold>
          <Bold>
            {t('rules.promotion.b3')}
          </Bold>
          <Bold>
            {t('rules.promotion.b4')}
          </Bold>

          <Text style={{ marginTop: `14px` }}>
            {t('rules.promotion.p16')}
          </Text>
          <Text>
            {t('rules.promotion.p17')}
          </Text>
          <Text>
            {t('rules.promotion.p18')}
          </Text>
          <Text>
            {t('rules.promotion.p19')}
          </Text>
          <Text>
            {t('rules.promotion.p20')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.promotion.t8')}</Title>
          <Text>
            {t('rules.promotion.p21')}
          </Text>
          <Text>
            {t('rules.promotion.p22')}
          </Text>
          <Text>
            {t('rules.promotion.p23')}
          </Text>

          <Text style={{ marginTop: `14px` }}>
            {t('rules.promotion.p24')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.promotion.t9')}</Title>
          <Text style={{marginBottom: `110px`}}>
            {t('rules.promotion.p25')}
          </Text>
        </TextWrapper>
      </BottomWrapper>
    </TopLevelWrapper>
  )
}

export default PromotionModel;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  background-color: ${props => props.theme.background};
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: min(1194px, 90%);
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
`;

const Bold = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;
